import { Component, AfterViewInit, OnDestroy, Output, EventEmitter, Renderer2, OnInit, OnChanges } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
    selector: 'app-generate-course-form-start',
    templateUrl: './generate-course-form-start.component.html',
    styleUrls: ['./generate-course-form-start.component.scss']
})

export class GenerateCourseFormStartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    userID = 0
    userOrg = 0
    categories: any[] = []

    courseFormID = 0
    courseFormName = ''
    courseFormHeadingWords = 300
    courseFormCategory = 0

    getCourseInfoSub = new Subscription
    getCategoriesSub = new Subscription

    @Output() moveEvent = new EventEmitter<any>()
    removeListener = new Function
    element: any

    constructor(private dataService: ApiService, private renderer: Renderer2, private route: ActivatedRoute) { }

    ngOnInit(): void {
        this.userID = this.dataService.getUserID()
        this.userOrg = this.dataService.getUserOrg()
        this.courseFormID = Number(this.route.snapshot.paramMap.get('course'))
        this.courseFormCategory = Number(this.route.snapshot.paramMap.get('category'))
        // console.log(this.courseFormID)
        // console.log(this.courseFormCategory)
        
        this.dataService.setCourseFormID(this.courseFormID)
        this.dataService.setCourseFormCategory(this.courseFormCategory)
        if (this.courseFormID > 0) {
            this.courseFormName = this.dataService.getCourseFormName()
            this.courseFormCategory = this.dataService.getCourseFormCategory()
            // console.log(this.courseFormName)
            // console.log(this.courseFormCategory)
            if (!this.courseFormName || this.courseFormName.length === 0 || !this.courseFormCategory) {
                this.getCourseInfoSub = this.dataService.getCourseInfo(this.courseFormID, this.userID)
                .subscribe(
                    course => {
                        // console.log(course)
                        this.courseFormName = course.name
                        this.courseFormCategory = +course.category
                        this.dataService.setCourseFormName(this.courseFormName)
                        this.dataService.setCourseFormCategory(this.courseFormCategory)
                    },
                    error => {
                        console.log(error)
                    }
                )
            }
        }
        // console.log(this.userID)
        // console.log(this.courseFormID)
        // console.log(this.courseFormName)
    
        this.getCategoriesSub = this.dataService.getCategories()
        .subscribe(
            categories => {
                // console.log(categories)
    
                if (categories.length == 1) {
                    this.courseFormCategory = +categories[0].id.replace('category_', '')
                }
    
                categories.forEach((category: any) => {
                    // console.log(category)
                    this.categories.push({
                        'id': +category.id.replace('category_', ''),
                        'name': category.text.trim()
                    })
                })
            },
            _error => {
                // console.log(error)
            },
        )
    
        this.element = document.getElementById('generate-course-form-start')
        this.removeListener = this.renderer.listen(this.element, 'animationend', () => {
            this.renderer.removeClass(this.element, 'animate__animated')
            this.renderer.removeClass(this.element, 'animate__fadeInRight')
            this.renderer.removeClass(this.element, 'animate__fast')
        })

        // console.log('form start init')
    }

    ngAfterViewInit(): void {
        // console.log('form start after view init')
    }

    ngOnChanges(): void {
        // console.log('form start changes')
    }
    
    ngOnDestroy(): void {
        this.getCourseInfoSub?.unsubscribe()
        this.getCategoriesSub?.unsubscribe()
        this.removeListener()

        // console.log('form start destroy')
    }

    move(event: MouseEvent) {
        let courseFormNameOK = this.courseFormName != ''
        // let headingWordsOK = this.headingWords > 0
        let courseFormCategoryOK = this.courseFormCategory > 0
        
        if (courseFormNameOK) {
            this.dataService.setCourseFormName(this.courseFormName)
        } else {
            alert('Por favor, escriba un nombre para su curso.')
        }

        /*
        if (headingWordsOK) {
            this.dataService.setCourseFormValue('heading-words', String(this.headingWords))
        } else {
            alert('Por favor, escriba un valor válido para las palabras por enunciado.')
        }
        */

        if (courseFormCategoryOK) {
            this.dataService.setCourseFormCategory(this.courseFormCategory)
        } else {
            alert('Por favor, seleccione una categoría.')
        }

        // console.log(localStorage)
        // if (courseNameOK && headingWordsOK && categoryOK) {
        if (courseFormNameOK && courseFormCategoryOK) {
            this.moveEvent.next(event)
        }
    }

}